/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectDailyTaskReportByConsultiveCommand } from '../../models/update-project-daily-task-report-by-consultive-command';
import { UpdateProjectDailyTaskReportByConsultiveCommandResult } from '../../models/update-project-daily-task-report-by-consultive-command-result';

export interface ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Params {
      body?: UpdateProjectDailyTaskReportByConsultiveCommand
}

export function apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch.PATH = '/api/ProjectDailyTaskReports/UpdateProjectDailyTaskReportByConsultive';
